import * as tokens from '../../../../../tokens/color.light.generated.js';
export const semanticColorLight = {
    color: {
        action: {
            primary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_LIGHT
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DISABLED_LIGHT
                    }
                }
            },
            secondary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DISABLED_LIGHT
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DISABLED_LIGHT
                    }
                }
            },
            tertiary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DISABLED_LIGHT
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_SELECTED_LIGHT,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DISABLED_LIGHT
                    }
                }
            }
        },
        navigation: {
            surface: {
                fill: {
                    default: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_INTERACTIVE_LIGHT,
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_ACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_DISABLED_LIGHT,
                    active: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_ACTIVE_LIGHT
                },
                stroke: {
                    default: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_INTERACTIVE_LIGHT,
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_ACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_DISABLED_LIGHT,
                    active: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_ACTIVE_LIGHT
                }
            },
            foreground: {
                icon: {
                    default: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_IDLE_LIGHT,
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_ACTIVE_LIGHT,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_DISABLED_LIGHT
                },
                text: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_LIGHT,
                    idle: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_LIGHT,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_DISABLED_LIGHT
                },
                indicator: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_LIGHT,
                    inactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_INACTIVE_LIGHT
                }
            }
        },
        forms: {
            foreground: {
                icons: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DISABLED_LIGHT,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_ERROR_LIGHT
                },
                text: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DISABLED_LIGHT,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_ERROR_LIGHT,
                    caption: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT
                },
                divider: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                },
                field: {
                    placeholder: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DISABLED_LIGHT
                    },
                    label: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_LIGHT
                    },
                    appendix: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_APPENDIX_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_APPENDIX_DISABLED_LIGHT
                    },
                    input: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DISABLED_LIGHT
                    },
                    icon: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_DISABLED_LIGHT,
                        error: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_ERROR_LIGHT
                    },
                    caption: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_CAPTION_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_CAPTION_DISABLED_LIGHT,
                        error: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ERROR_CAPTION_DEFAULT_LIGHT
                    },
                    extension: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_EXTENSION_DEFAULT_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_EXTENSION_DISABLED_LIGHT
                    }
                },
                control: {
                    selected: {
                        indicator: {
                            idle: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_IDLE_LIGHT,
                            interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_INTERACTIVE_LIGHT,
                            disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_DISABLED_LIGHT,
                            error: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_ERROR_LIGHT
                        }
                    }
                }
            },
            surface: {
                field: {
                    stroke: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DEFAULT_LIGHT,
                        error: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_ERROR_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DISABLED_LIGHT,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_LIGHT,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_READ_ONLY_LIGHT,
                        focus: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_FOCUS_LIGHT
                    },
                    fill: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_LIGHT,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_INTERACTIVE_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DISABLED_LIGHT,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_READ_ONLY_LIGHT,
                        focus: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_FOCUS_LIGHT
                    }
                },
                control: {
                    default: {
                        stroke: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_IDLE_LIGHT,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_DISABLED_LIGHT,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_ERROR_LIGHT
                        },
                        fill: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_IDLE_LIGHT,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_DISABLED_LIGHT,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_ERROR_LIGHT
                        }
                    },
                    selected: {
                        stroke: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_IDLE_LIGHT,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_DISABLED_LIGHT,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_ERROR_LIGHT
                        },
                        fill: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_IDLE_LIGHT,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_DISABLED_LIGHT,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_ERROR_LIGHT
                        }
                    }
                }
            }
        },
        ui: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DISABLED_LIGHT,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_INTERACTIVE_LIGHT
                },
                divider: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                },
                icons: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DEFAULT_LIGHT,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DISABLED_LIGHT,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_INTERACTIVE_LIGHT
                }
            },
            surface: {
                scrim: {
                    default: tokens.SEM_COLOR_UI_SURFACE_SCRIM_DEFAULT_LIGHT
                }
            }
        },
        feedback: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    informative: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_LIGHT,
                    inverted: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INVERTED_LIGHT
                },
                icon: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_DEFAULT_LIGHT,
                    success: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_SUCCESS_LIGHT,
                    warning: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_WARNING_LIGHT,
                    error: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_ERROR_LIGHT
                }
            },
            surface: {
                informative: tokens.SEM_COLOR_FEEDBACK_SURFACE_INFORMATIVE_LIGHT,
                success: tokens.SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_LIGHT,
                error: tokens.SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT,
                notice: tokens.SEM_COLOR_FEEDBACK_SURFACE_NOTICE_LIGHT
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map